import { SHOW_LOADER } from './constants';

interface Payload {
  timeout: number;
  msg: string;
}

export const showLoader = (payload: Payload) => ({
  type: SHOW_LOADER,
  data: payload,
});
